<template>
    <div>
        <div v-if="horse && need_show_horsename" class="row d-flex justify-content-between">
            <div class="col-sm-6 text-left">
                <router-link :to="{ name: 'horseFiche', params: { horse_id: horse.horse_id }}">
                    <font-awesome-icon :icon="['fas', 'horse-head']" /> {{ horse.horse_nom }}
                </router-link>
            </div>
        </div>
        <div class="row align-items-center justify-content-between">
            <div class="col-6 col-md-3 order-1">
                <SeasonInput v-model="seasonSelected" @change="changeSeason"/>
            </div>

            <div class="col-12 col-md-6 text-center order-3 order-md-2 mt-2 mt-md-0">
                <b v-if="seasonMareStallion && seasonMareStallion.horse">
                    {{ $t("gynecologie.etalon_en_cours") }} :
                    <router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: seasonMareStallion.horse.horse_id }}">
                        <span v-if="seasonMareStallion.seasonmarestallion_porteuse === seasonMare.seasonmare_id">
                            {{ seasonMareStallion.mare.horse.horse_nom }} x {{ seasonMareStallion.horse.horse_nom }}
                        </span>
                        <span v-else>
                            {{ seasonMareStallion.horse.horse_nom }}
                        </span>
                    </router-link>
                    <span v-if="seasonMareStallion.seasonmarestallion_num_dps != null">
                        ({{ $t("gynecologie.dps") }} {{ seasonMareStallion.seasonmarestallion_num_dps }}
                        <font-awesome-icon v-if="seasonMareStallion.seasonmarestallion_dps_done" class="text-success" :icon="['fal', 'check-circle']" />
                        )
                    </span>
                    <a
                        v-if="seasonMareStallion.contact && seasonMareStallion.contact.length > 0"
                        href="#"
                        @click.prevent="$refs.modal_stallion_contacts.show()"
                    >
                        <font-awesome-icon :icon="['fal', 'phone']" />
                    </a>
                    - {{ seasonMareStallion.seasonmarestallion_status }}
                </b>
                <b-button
                    v-else-if="Object.keys(seasonMare).length > 0 && !horseFicheReadOnly"
                    variant="primary"
                    @click="goToHistory(true)"
                >
                    {{ $t("gynecologie.choisir_etalon_saison") }}
                </b-button>
                <small v-if="!previous_season_status && seasonMare.seasonmare_status">
                    <br />{{ $t("gynecologie.mare_previous_status_declared") }} : {{ actual_season_status}}
                </small>
                <small v-if="previous_season_status">
                    <br />{{ $t("gynecologie.mare_previous_status") }} :
                    <router-link v-if="previous_season_status.horse_nom && previous_season_status.horse_id" :to="{ name: 'horseFiche', params: { horse_id: previous_season_status.horse_id }}">
                        {{ previous_season_status.horse_nom }}
                    </router-link>
                    - {{ previous_season_status.status }}
                </small>
            </div>


            <div class="col-6 col-md-3 gyneco-actions d-flex flex-wrap justify-content-end order-2 order-md-3">
                <b-dropdown split block variant="primary" class="w-100" v-e-online-only @click="load_pdf_suivi">
                    <template #button-content>
                        {{ $t("gynecologie.imprimer_suivi") }}
                    </template>
                    <b-dropdown-item
                        v-e-online-only
                        v-if="horse.horse_sire && !mask_ifce"
                        :href="`https://infochevaux.ifce.fr/externe/${horse.horse_sire}`"
                        target="_blank"
                    >
                        {{ $t('horse.voir_fiche_ifce') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="load_info_contact">
                        {{ $t("gynecologie.info_contact.title") }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="horse && horse.horse_sire" @click="load_dps_ws">
                        {{ $t('gynecologie.titre_dps_saillie_ws') }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="seasonMare.horse && !seasonMareStallion.horse" @click="delete_from_season">
                        <font-awesome-icon v-if="processing_season_delete" :icon="['fal', 'spinner']" spin /><font-awesome-icon v-else :icon="['fal', 'times']" class="mr-1" />{{ $t("gynecologie.delete_from_season") }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>




        <LoadingSpinner class="col-12" v-if="processing_seasonmare" />
        <template v-else>
            <template v-if="Object.keys(seasonMare).length > 0">
                <div class="row  mt-2">
                    <div class="col d-flex flex-wrap justify-content-center gyneco-status-actions">
                        <button
                            v-for="toggle in statusToggles"
                            :key="toggle.field"
                            type="button"
                            class="btn d-inline-flex align-items-center"
                            :class="seasonMare[toggle.field] ? 'btn-outline-success' : 'btn-outline-primary'"
                            @click="toggleSeasonFlag(toggle)"
                        >
                            <input
                                type="checkbox"
                                class="sanitary-check mr-2"
                                :checked="seasonMare[toggle.field]"
                                tabindex="-1"
                                @click.prevent
                            >
                            <span class="text-truncate">{{ toggle.label }}</span>
                        </button>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12 d-flex flex-column">
                        <div
                            v-if="seasonMare.seasonmare_commentary"
                            class="alert alert-warning mb-0"
                            role="button"
                            @click="openCommentModal"
                        >
                            <span class="comment-html" v-html="seasonMare.seasonmare_commentary"></span>
                        </div>
                        <button
                            v-else
                            class="btn btn-outline-secondary btn-block"
                            @click.prevent="openCommentModal"
                        >
                            <font-awesome-icon :icon="['fal', 'plus']" class="mr-1" />{{ $t("gynecologie.commentaire_saison") }}
                        </button>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <!-- Desktop : onglets classiques -->
                        <ul class="nav nav-tabs d-none d-md-flex">
                            <li v-for="tab in gynecoTabs" :key="tab.key" class="nav-item">
                                <a class="nav-link" :class="{ active: activeTab === tab.key }" @click="toggleTab(tab.key)">
                                    {{ tab.label }}
                                </a>
                            </li>
                        </ul>

                        <!-- Mobile : un seul onglet visible + chevron pour changer -->
                        <b-dropdown class="d-md-none gyneco-tabs-dropdown" block variant="outline-primary" :text="activeTabLabel" menu-class="w-100">
                            <b-dropdown-item
                                v-for="tab in gynecoTabs"
                                :key="tab.key"
                                :active="activeTab === tab.key"
                                @click="toggleTab(tab.key)"
                            >
                                {{ tab.label }}
                            </b-dropdown-item>
                        </b-dropdown>

                        <div v-if="activeTab" class="border border-top-0 rounded-bottom p-2">
                            <Goals
                                v-if="activeTab === 'objectifs'"
                                :key="'gyneco-tab-objectifs-' + tabKey"
                                :season="seasonSelected"
                                :season_mare="seasonMare"
                            />
                            <HorseHistoriqueSaisonEtalon
                                v-else-if="activeTab === 'croisements'"
                                :key="'gyneco-tab-croisements-' + tabKey"
                                :season_id="seasonSelected.id"
                                :horse_id="horse.horse_id"
                                :goToAddHorseStallion="openAddStallion"
                            />
                            <EmbryonSeason
                                v-else-if="activeTab === 'embryons'"
                                :key="'gyneco-tab-embryons-' + tabKey"
                                :season_id="seasonSelected.id"
                                :horse_id="horse.horse_id"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <div v-else-if="seasonSelected && !horseFicheReadOnly" class="text-center my-4">
                <b-button variant="primary" :disabled="isAddingHorse" @click="addHorseSeason">
                    {{ $t('gynecologie.activer_jument_dans_saison', { season: seasonSelected.name }) }}
                </b-button>
            </div>
        </template>


        <div v-if="scheduled_saillies && scheduled_saillies.length > 0" class="alert alert-info mt-1">
            {{ $t("gynecologie.saillie_reservee") }} 
            <span v-if="scheduled_saillies[0] && scheduled_saillies[0].stallion_nom">
                <router-link v-if="scheduled_saillies[0].planning_type == 'IA'" :to="{ name: 'planningIABeta', params: {planning_date: scheduled_saillies[0].planning_date}}">
                    {{ scheduled_saillies[0].planning_date_formatted }} 
                </router-link>
                <router-link v-else :to="{ name: 'planningMainBeta', params: {planning_date: scheduled_saillies[0].planning_date}}">
                    {{ scheduled_saillies[0].planning_date_formatted }} 
                </router-link>
                {{' ' + $t("gynecologie.at") + ' ' + scheduled_saillies[0].planning_start + ' ' + $t("gynecologie.avec") }}
                <router-link :to="{ name: 'horseFiche', params: { horse_id: scheduled_saillies[0].stallion_id }}">
                    {{ scheduled_saillies[0].stallion_nom }}
                </router-link>
            </span>
            <span v-if="scheduled_saillies[1] && scheduled_saillies[1].stallion_nom">, 
                <router-link v-if="scheduled_saillies[1].planning_type == 'IA'" :to="{ name: 'planningIABeta', params: {planning_date: scheduled_saillies[1].planning_date}}">
                    {{ scheduled_saillies[1].planning_date_formatted }} 
                </router-link>
                <router-link v-else :to="{ name: 'planningMainBeta', params: {planning_date: scheduled_saillies[1].planning_date}}">
                    {{ scheduled_saillies[1].planning_date_formatted }} 
                </router-link>
                {{' ' + $t("gynecologie.at") + ' ' + scheduled_saillies[1].planning_start + ' ' + $t("gynecologie.avec") }}
                <router-link :to="{ name: 'horseFiche', params: { horse_id: scheduled_saillies[1].stallion_id }}">
                    {{ scheduled_saillies[1].stallion_nom }}
                </router-link>
            </span>
        </div>

        <div class="mt-4" v-show="Object.keys(seasonMare).length > 0">
            <Actes
                ref="ActSummary"
                :horse_id="horse.horse_id"
                :actual_season_mare_stallion="seasonMareStallion"
            />
        </div>

        <b-modal ref="modalDps" hide-footer>
            <template v-slot:modal-title>
                {{ $t('gynecologie.titre_dps_saillie_ws') }}
            </template>

            <div v-if="!modal_dps_loaded">
                <LoadingSpinner class="col-12" />
            </div>
            
            <div v-if="modal_dps_loaded">
                <template v-if="!dps.length">
                    {{ $t('gynecologie.aucune_donnee_dps_saillie_ws') }}
                </template>
                <template v-else>
                    <div v-if="error_dps" class="alert alert-warning">
                        {{ $t('gynecologie.erreur_dps_saillie_ws') }}
                    </div>
                    
                    <WarnAlert messageI18n="monte.dps_creation_acte" />
                    
                    <div class="my-3" v-for="data in dps" v-bind:key="data.monteSaillie">
                        {{ $t('horse.etalon') }} : <b>{{ data.etalonNom }}</b>
                        <br>
                        {{ $t('monte.porteuse') }} : <b>{{ data.porteuseNom }}</b>
                        <br>
                        {{ $t('monte.date_premier_saut') }} : <b>{{ data.monteDatePremierSaut_format }}</b>
                        <br>
                        {{ $t('compte.datenaissance') }} : <b>{{ data.produitDateNaiss_format }}</b>
                        <br>
                        {{ $t('horse.nom_naissance') }} : <b>{{ data.produitNom }}</b>
                        <br>
                        {{ $t('horse.nom_retenue') }} : <b>{{ data.nomRetenu }}</b>
                        
                        <e-select
                            v-model="data.acte_type"
                            id="actestype_id"
                            track-by="actestype_id"
                            label="actestype_label"
                            :placeholder="$t('acte.selectionnez_acte')"
                            :selectedLabel="$t('global.selected_label')"
                            :options="actes_types"
                            :searchable="true"
                            :allow-empty="false"
                            :show-labels="false"
                            :group-select="false"
                        >
                         <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                        </e-select>
                    
                        <div class="text-center mt-3">
                            <b-form-checkbox v-model="data.selected"></b-form-checkbox>
                        </div>
                    </div>
                
                    <div class="text-center mt-3">
                        <b-button variant="primary" :disabled="loading_add_dps" @click="add_dps()">
                            <font-awesome-icon v-if="loading_add_dps" :icon="['fas', 'spinner']" pulse />
                            {{ $t('global.ajouter') }}
                        </b-button>
                        <b-button class="ml-2" variant="secondary" :disabled="loading_add_dps_commentaire" @click="add_dps_commentaire()">
                            <font-awesome-icon v-if="loading_add_dps_commentaire" :icon="['fas', 'spinner']" pulse />
                            {{ $t('gynecologie.add_dps_commentaire') }}
                        </b-button>
                    </div>
                </template>
            </div>
        </b-modal>

        <ModalConfirm
            ref="confirm_season_delete"
            id="confirm_season_delete_c"
            :icon="['fal', 'check']"
            :icon_accept="['fal', 'level-down']"
            :text_title="$t('modal.horse.validation_season_delete')"
            :text_question="$t('modal.horse.text_validation_season_delete')"
            :text_button_ok="$t('modal.horse.desassocier')"
            :text_button_cancel="$t('modal.general.annuler')"
            :callback_validation="confirmSwitchSaveSeasonDeleteModal"
            :callback_cancel="cancelSwitchSeasonDeleteModal"
            :processing="processing_season_delete"
        />

        <b-modal ref="modal_comment" size="lg" hide-footer>
            <template #modal-title>{{ $t("gynecologie.commentaire_saison") }}</template>
            <div class="form-group">
                <e-editor-froala
                    ref="froala_season_comment"
                    identifier="seasonmare_commentaire_modal"
                    :placeholder="$t('gynecologie.commentaire_saison')"
                    :content="comment_modal_text"
                    @change="updateCommentEditor"
                    :moreText="froala_more_text"
                    :enableImage="false"
                ></e-editor-froala>
            </div>
            <div class="comment-modal-footer d-flex flex-column flex-sm-row justify-content-sm-between mt-4">
                <button
                    type="button"
                    class="btn btn-danger text-nowrap"
                    :disabled="comment_processing || !seasonMare.seasonmare_commentary"
                    @click="deleteComment"
                >
                    <font-awesome-icon v-if="comment_processing" :icon="['fas', 'spinner']" pulse />
                    <font-awesome-icon v-else :icon="['fal', 'trash-alt']" class="mr-1" />{{ $t('action.supprimer') }}
                </button>
                <div class="d-flex flex-column flex-sm-row">
                    <button type="button" class="btn btn-secondary text-nowrap" @click="$refs.modal_comment.hide()">
                        {{ $t('global.annuler') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary text-nowrap"
                        :disabled="comment_processing"
                        @click="saveCommentFromModal"
                    >
                        <font-awesome-icon v-if="comment_processing" :icon="['fas', 'spinner']" pulse />
                        <font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1" />{{ $t('global.enregistrer') }}
                    </button>
                </div>
            </div>
        </b-modal>

        <b-modal ref="modal_stallion_contacts" hide-footer>
            <template #modal-title>
                {{ $t("gynecologie.info_contact.title") }} - {{ seasonMareStallion && seasonMareStallion.horse ? seasonMareStallion.horse.horse_nom : '' }}
            </template>
            <template v-if="seasonMareStallion && seasonMareStallion.contact">
                <div v-for="(contact, index_c) in seasonMareStallion.contact" :key="'stallion_contact_'+index_c">
                    <hr v-if="index_c > 0" class="my-2">
                    <div class="row">
                        <div class="col">
                            {{ contact.contact_firstname }} {{ contact.contact_lastname }}
                        </div>
                        <div class="col-auto ml-auto">
                            <div v-for="(phone, index_p) in contact.phones" :key="'stallion_phone_'+index_p">
                                <a :href="'tel:' + phone.phone_indicatif + phone.phone_numero">{{ phone.phone_indicatif }} {{ phone.phone_numero }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script type="text/javascript">
import TableAction from "@/mixins/TableAction.js"
import Navigation from "@/mixins/Navigation.js"
import HorseMixin from "@/mixins/Horse.js"
import GynecologieMixin from "@/mixins/Gynecologie.js"
import PlanningMonteMixin from "@/mixins/PlanningMonte.js"
import ActeTypeMixin from "@/mixins/ActeType.js"
import Shutter from "@/mixins/Shutter.js"
import ShutterGyneco from "@/mixins/shutters-manager/Gyneco.js"
import Common from '@/assets/js/common.js'

// Clé de mémorisation (navigateur) de l'onglet gynéco à ouvrir par défaut
const TAB_STORAGE_KEY = 'gyneco_default_tab'

export default {
    name: "GynecologieHorse",
    mixins: [
        TableAction,
        Navigation,
        HorseMixin,
        GynecologieMixin,
        ActeTypeMixin,
        PlanningMonteMixin,
        Shutter,
        ShutterGyneco
    ],
    props: {
        'horse': { type: Object, default: null },
        'horse_id': { type: String, default: '' },
        'need_show_horsename': { type: Boolean, default: false }
    },
    data () {
        return {
            seasonSelected: null,
            seasonMareHorse: null,
            seasonMare: {},
            seasonMareStallion: {},
            previous_season_status: null,
            events_tab: {
                'GynecologieHorse::reload': (openHistorique) => {
                    this.reload(openHistorique)
                },
            },
            reloadMethod: 'reloadActs',
            isAddingHorse: false,
            modal_dps_loaded: false,
            dps: null,
            loading_add_dps: false,
            error_dps: false,
            loading_add_dps_commentaire: false,
            mask_ifce: false,
            processing_seasonmare: false,
            actes_types: [],
            scheduled_saillies: [],
            processing_season_delete: false,
            mare_status: [],
            activeTab: null,
            tabKey: 0,
            openAddStallion: false,
            comment_modal_text: '',
            comment_processing: false,
            froala_more_text: ['bold', 'italic', 'underline', 'strikeThrough', 'undo', 'redo', 'formatUL', 'formatOL', 'clearFormatting']
        }
    },
    mounted() {
        this.init_component()
    },
    methods: {
        async init_component() {
            this.mask_ifce = this.getConfigIfce()
            // Récupération des saillies prévues dans les deux prochains jours
            this.loadMarePlanning()
            this.mare_status = await this.loadMareStatus()
            this.restoreActiveTab()
        },
        // Restaure l'onglet mémorisé en localStorage (l'onglet objectifs est ignoré sans le droit)
        restoreActiveTab() {
            const savedTab = localStorage.getItem(TAB_STORAGE_KEY)
            if(savedTab === 'objectifs' && !this.hasObjectifsAccess) {
                localStorage.removeItem(TAB_STORAGE_KEY)
                return
            }
            if(['objectifs', 'croisements', 'embryons'].includes(savedTab)) {
                this.activeTab = savedTab
            }
        },
        toggleTab(tab) {
            if(this.activeTab === tab) {
                this.activeTab = null
                localStorage.removeItem(TAB_STORAGE_KEY)
            } else {
                this.activeTab = tab
                localStorage.setItem(TAB_STORAGE_KEY, tab)
            }
        },
        dateWithoutTime(date) {
            return new Date(date.setHours(0,0,0,0))
        },
        async loadMarePlanning() {
            let mare_plannings = await this.getPlanningInfoByMare(this.horse.horse_id)
            let currentDate = this.dateWithoutTime(new Date())
            const millisec_in_day =  24 * 60 * 60 * 1000
            let limitDate = new Date(currentDate.getTime() + millisec_in_day * 2)
            
            // On ne garde que les créneaux réservé dans les 2 prochains jours
            mare_plannings = mare_plannings.filter((planning) => {
                return new Date(planning.planning_date) >= currentDate && new Date(planning.planning_date) <= limitDate
            }
            )
            
            // On trie les créneaux par date
            mare_plannings.sort((a,b) => 
            new Date(a.planning_date) - new Date(b.planning_date)
            )
            
            // On prend les deux premiers
            this.scheduled_saillies = mare_plannings.slice(0,2)
        },
        async loadSeasonMare() {
            if(!this.seasonSelected) return
            
            this.seasonMareHorse = await this.loadSeasonMareStallionBySeasonHorse(this.horse.horse_id, this.seasonSelected.id, false)
        },
        async reload(openHistorique) {
            this.openAddStallion = false
            if(openHistorique) {
                this.activeTab = 'croisements'
            }
            await this.changeSeason()
        },
        async changeSeason() {

            if(this.seasonSelected && this.$refs.ActSummary) {
                this.$refs.ActSummary.reload(this.seasonSelected)
            }
            this.processing_seasonmare = true
            await this.loadSeasonMare()
            
            this.seasonMare = {}
            this.seasonMareStallion = {}
            this.previous_season_status = null
            
            if(this.seasonMareHorse && this.seasonSelected) {
                // Récupération de la saison par défault
                for(let i = 0; i < this.seasonMareHorse.length; i++) {
                    if(this.seasonSelected.id == this.seasonMareHorse[i].season.season_id) {
                        this.seasonMare = this.seasonMareHorse[i]
                        
                        // Récupération du cheval par défault
                        let seasonmarestallion = this.seasonMare.seasonmarestallion
                        if(seasonmarestallion) {
                            for(let y = 0; y < seasonmarestallion.length; y++) {
                                if(seasonmarestallion[y].seasonmarestallion_default && (seasonmarestallion[y].porteuse == null || (seasonmarestallion[y].porteuse && seasonmarestallion[y].porteuse.horse.horse_id == this.horse.horse_id))) {
                                    // Recuperation des contact
                                    let contact = []
                                    let horseContact = seasonmarestallion[y].horse.contact
                                    if(horseContact) {
                                        for (let u = 0; u < horseContact.length; u++) {
                                            
                                            // Récupération de la fonction "etalonnier"
                                            let contactFonction = horseContact[u].fonctions
                                            if(contactFonction) {
                                                for (var o = 0; o < contactFonction.length; o++) {
                                                    if(contactFonction[o].fonction_code == "ETAL") {
                                                        contact.push(horseContact[u].contact)
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    
                                    seasonmarestallion[y].contact = contact
                                    this.seasonMareStallion = seasonmarestallion[y]
                                }
                            }
                        }
                    }
                }
                
                if(!this.seasonMareStallion.seasonmarestallion_id && this.seasonMare.seasonmarestallion && this.seasonMare.seasonmarestallion.length > 0) {
                    let contact = []
                    let horseContact = this.seasonMare.seasonmarestallion[0].horse.contact
                    if(horseContact) {
                        for (let u = 0; u < horseContact.length; u++) {
                            
                            // Récupération de la fonction "etalonnier"
                            let contactFonction = horseContact[u].fonctions
                            if(contactFonction) {
                                for (var p = 0; p < contactFonction.length; p++) {
                                    if(contactFonction[p].fonction_code == "ETAL") {
                                        contact.push(horseContact[u].contact)
                                    }
                                }
                            }
                        }
                    }
                    
                    this.seasonMare.seasonmarestallion[0].contact = contact
                    this.seasonMareStallion = this.seasonMare.seasonmarestallion[0]
                }
                
                // Récupération du status de la saison actuelle
                if(this.seasonMareStallion && this.seasonMareStallion.seasonmarestallion_status && (this.seasonMareStallion.porteuse == null || this.seasonMareStallion.seasonmarestallion_porteuse == this.horse.horse_id)) {
                    this.seasonMareStallion.seasonmarestallion_status = Common.translateSeasonMareStatus(this.seasonMareStallion.seasonmarestallion_status)
                }
                
                // Récupération du status de la saison précédente
                const previous_season = await this.getPreviousSeasonFromSeason(this.seasonSelected.id)
                if(previous_season) {
                    let previous_season_status = await this.loadSeasonMareStallionStatus(previous_season)
                    if(previous_season_status) {
                        this.previous_season_status = previous_season_status
                        this.previous_season_status.status = previous_season_status.status ? Common.translateSeasonMareStatus(previous_season_status.status) : null
                    }                        
                }

            }
            this.processing_seasonmare = false
            // Force le remontage de l'onglet ouvert pour rafraîchir ses données
            this.tabKey++
        },
        async loadSeasonMareStallionStatus(season) {
            let seasonMareHorse = await this.loadSeasonMareStallionBySeasonHorse(this.horse.horse_id, season.season_id)
            
            if(seasonMareHorse.length === 0) return null
            
            let seasonMare = {}
            let seasonMareStallion = {}
            if(seasonMareHorse && season) {
                for(let i = 0; i < seasonMareHorse.length; i++) {
                    if(season.season_id == seasonMareHorse[i].season.season_id) {
                        seasonMare = seasonMareHorse[i]
                        let seasonmarestallion = seasonMare.seasonmarestallion
                        if(seasonmarestallion) {
                            for(let y = 0; y < seasonmarestallion.length; y++) {
                                // on prend l'état physio de la jument si couple ou si trouple avec jument en porteuse
                                if((seasonmarestallion[y].mare.horse.horse_id == this.horse.horse_id && seasonmarestallion[y].porteuse == null) || (seasonmarestallion[y].porteuse && seasonmarestallion[y].porteuse.horse.horse_id == this.horse.horse_id)) {
                                    seasonMareStallion = seasonmarestallion[y]
                                }
                            }
                        }
                    }
                }
            }
            if (seasonMareStallion) {
                if (seasonMareStallion.porteuse && seasonMareStallion.porteuse.horse.horse_id == this.horse.horse_id) {
                    return {
                        "status": seasonMareStallion.seasonmarestallion_status,
                        "horse_nom": seasonMareStallion.horse.horse_nom,
                        "horse_id": seasonMareStallion.horse.horse_id,
                        "donneuse_nom": seasonMareStallion.mare.horse.horse_nom,
                        "donneuse_id": seasonMareStallion.mare.horse.horse_id,
                    }
                    
                } 
                if (seasonMareStallion.horse) {
                    return {
                        "status": seasonMareStallion.seasonmarestallion_status,
                        "horse_nom": seasonMareStallion.horse.horse_nom,
                        "horse_id": seasonMareStallion.horse.horse_id,
                    }
                }
            }
            return null
        },
        async addHorseSeason() {
            this.isAddingHorse = true
            
            const result = await this.addHorseSeasonMare(
            this.seasonSelected.id,
            this.horse.horse_id,
            ""
            );
            
            if(result) {
                await this.reload()
            }
            
            this.isAddingHorse = false
        },
        async saveCommentary(value) {
            const result = await this.editSeasonMare(
            this.seasonMare.seasonmare_id,
            {seasonmare_commentary: value}
            );

            if(result) {
                this.seasonMare.seasonmare_commentary = value
            }
            return result
        },
        openCommentModal() {
            this.comment_modal_text = this.seasonMare.seasonmare_commentary || ''
            this.$refs.modal_comment.show()
            this.$nextTick(() => {
                if(this.$refs.froala_season_comment) {
                    this.$refs.froala_season_comment.setValue(this.comment_modal_text)
                }
            })
        },
        updateCommentEditor(hook) {
            this.comment_modal_text = hook.val
        },
        async saveCommentFromModal() {
            this.comment_processing = true
            const html = this.comment_modal_text || ''
            // Considère le commentaire vide si Froala renvoie son balisage vide
            const stripped = html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '').trim()
            await this.saveCommentary(stripped ? html : '')
            this.comment_processing = false
            this.$refs.modal_comment.hide()
        },
        async deleteComment() {
            this.comment_processing = true
            await this.saveCommentary('')
            this.comment_modal_text = ''
            this.comment_processing = false
            this.$refs.modal_comment.hide()
        },
        goToHistory(openAdd=false) {
            this.openAddStallion = openAdd
            this.activeTab = 'croisements'
            // Remonte le contenu de l'onglet : goToAddHorseStallion n'est lu qu'à l'initialisation du composant
            this.tabKey++
        },
        goToGoals() {
            this.activeTab = 'objectifs'
        },
        reloadActs() {
            const reloadActMethod = this.$refs.ActSummary.reloadMethod
            this.$refs.ActSummary[reloadActMethod](this.seasonSelected)
        },
        // Inverse un indicateur de la saison (sanitaire, contrats) et le persiste via la config statusToggles
        toggleSeasonFlag(toggle) {
            const bool = !this.seasonMare[toggle.field]
            this.seasonMare[toggle.field] = bool
            toggle.save(bool)
        },
        // Persiste un indicateur de réception de contrat (transfert ou pension)
        async saveContractFlag(saveMethod, bool) {
            await saveMethod(this.seasonMare.seasonmare_id, bool)
            this.successToast('toast.info_modif_succes')
        },
        async save_sanitary(bool) {
            const res = await this.saveSanitary(this.seasonMare.seasonmare_id, bool)
            if(res == 1) {
                this.successToast("toast.info_modif_succes")
            } else {
                this.failureToast()
            }
        },
        load_pdf_suivi() {
            this.generatePdfSuiviGyneco(this.horse.horse_id, this.seasonSelected.id, this.seasonMareStallion.horse ? this.seasonMareStallion.horse.horse_id : null)
        },
        load_info_contact() {
            this.setupHorseInfoContact(this.horse.horse_id)
        },
        cancelSwitchSeasonDeleteModal() {
            this.$refs.confirm_season_delete.closeModal()
        },
        delete_from_season(){
            this.$refs.confirm_season_delete.openModal()
        },
        async confirmSwitchSaveSeasonDeleteModal() {
            this.processing_season_delete = true
            await this.deleteSeasonMare(this.seasonMare.seasonmare_id)
            this.$refs.confirm_season_delete.closeModal()
            this.successToast('toast.info_save_succes')
            this.processing_season_delete = false
            await this.changeSeason()
        },
        async load_dps_ws() {
            this.modal_dps_loaded = false
            this.$refs['modalDps'].show()
            this.actes_types = await this.getActeTypeSaillie()
            
            let dps = await this.getInfoSailliesWs(this.horse.horse_id, this.seasonSelected.id)
            for(let i = 0; i < dps.length; i++) {
                dps[i].selected = true
                dps[i].acte_type = this.actes_types[0]
            }
            
            this.dps = dps
            this.modal_dps_loaded = true
        },
        async add_dps() {
            this.loading_add_dps = true;
            
            const checked = this.dps
            .filter(_dps => _dps.selected);
            
            let data = []
            for(let i = 0; i < checked.length; i++) {
                data.push({
                    monteSaillie: checked[i].monteSaillie,
                    monteAnnee: checked[i].monteAnnee,
                    monteActeType: checked[i].acte_type.actestype_id
                })
            }
            
            if(data) {
                this.error_dps = false
                const result = await this.AddInfoSailliesWs(this.horse.horse_id, data)
                if(result) {
                    if(result.retour.erreur == false) {
                        await this.$sync.force(true)
                        await this.reload()
                        this.successToast()
                        this.$refs['modalDps'].hide()
                    } else {
                        this.error_dps = true
                    }
                }
            }
            
            this.loading_add_dps = false;
        },
        async add_dps_commentaire() {
            this.loading_add_dps_commentaire = true;
            
            const checked = this.dps
            .filter(_dps => _dps.selected);
            
            let data = this.seasonMare.seasonmare_commentary
            for(let i = 0; i < checked.length; i++) {
                if(data) {
                    data += '\n\n'
                }
                
                data += this.getTrad('horse.etalon')+' : '+(checked[i].etalonNom ?? '')+'\n'+this.getTrad('monte.porteuse')+' : '+(checked[i].porteuseNom ?? '')+'\n'+this.getTrad('monte.date_premier_saut')+' : '+(checked[i].monteDatePremierSaut_format ?? '')+'\n'+this.getTrad('compte.datenaissance')+' : '+(checked[i].produitDateNaiss_format ?? '')+'\n'+(this.getTrad('horse.nom_naissance') ?? '')+' : '+(checked[i].produitNom ?? '')+'\n'+this.getTrad('horse.nom_retenue')+' : '+(checked[i].nomRetenu ?? '')+'\n'+this.getTrad('horse.type_monte')+' : '+this.getTrad('actes_type.'+checked[i].acte_type.actestype_code)+''
            }
            
            if(data) {
                this.saveCommentary(data)
            }
            
            this.loading_add_dps_commentaire = false;
        }
    },
    computed: {
        actual_season_status(){
            return this.getTrad('gynecologie.'+this.mare_status.find(status => status.marestatus_id == this.seasonMare.seasonmare_status).marestatus_code)
        },
        horseFicheReadOnly() {
            return this.$store.state.horseFicheReadonly
        },
        hasObjectifsAccess() {
            return this.$store.state.userAccess.hasObjectifsAccess
        },
        // Liste des onglets gynéco (partagée entre la version desktop nav-tabs et le dropdown mobile)
        gynecoTabs() {
            const tabs = []
            if(this.hasObjectifsAccess) tabs.push({ key: 'objectifs', label: this.$t('gynecologie.goals') })
            tabs.push({ key: 'croisements', label: this.$t('gynecologie.croisements') })
            tabs.push({ key: 'embryons', label: this.$t('gynecologie.embryons') })
            return tabs
        },
        activeTabLabel() {
            const tab = this.gynecoTabs.find(t => t.key === this.activeTab)
            return tab ? tab.label : this.$t('gynecologie.choisir_onglet')
        },
        // Boutons toggle de statut de la saison (champ de seasonMare + méthode de sauvegarde associée)
        statusToggles() {
            const toggles = [
                { field: 'seasonmare_sanitary', label: this.$t('gynecologie.sanitaire_complet'), save: this.save_sanitary }
            ]
            if(this.hasObjectifsAccess) {
                toggles.push({ field: 'seasonmare_contract_transfert', label: this.$t('gynecologie.contract_transfert_recu'), save: (bool) => this.saveContractFlag(this.saveContractTransfert, bool) })
            }
            toggles.push({ field: 'seasonmare_contract_pension', label: this.$t('gynecologie.contract_pension_recu'), save: (bool) => this.saveContractFlag(this.saveContractPension, bool) })
            return toggles
        }
    },
    components: {
        LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
        CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
        SeasonInput : () => import('@/components/Inputs/SeasonInput'),
        Actes : () => import('@/components/Gynecologie/Actes'),
        WarnAlert : () => import('GroomyRoot/components/Alert/WarnAlert'),
        ModalConfirm : () => import('@/components/Modals/ModalConfirm'),
        Goals : () => import('@/components/Gynecologie/Goals'),
        HorseHistoriqueSaisonEtalon : () => import('@/components/Gynecologie/HorseHistoriqueSaisonEtalon'),
        EmbryonSeason : () => import('@/components/Gynecologie/EmbryonSeason')
    },
}
</script>

<style lang="scss" scoped>
// Dropdown des onglets (mobile) : libellé à gauche, chevron collé à droite
.gyneco-tabs-dropdown ::v-deep .dropdown-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

// Labels du dropdown sur une seule ligne (ellipsis si trop long) — plus propre sur mobile
.gyneco-actions ::v-deep .btn:not(.dropdown-toggle-split) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}
.gyneco-actions ::v-deep .dropdown-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

// Boutons statut (sanitaire / contrats) : espacement et libellés sur une seule ligne
.gyneco-status-actions {
    gap: 0.5rem;
}
.gyneco-status-actions .btn {
    min-width: 0;
}
.gyneco-status-actions .btn .text-truncate {
    min-width: 0;
}
.gyneco-status-actions .sanitary-check {
    flex-shrink: 0;
}

// Footer de la modal commentaire : espacement des boutons (empilés sur mobile, en ligne sur sm+)
.comment-modal-footer,
.comment-modal-footer > div {
    gap: 0.5rem;
}

// Sur mobile : les 3 boutons statut côte à côte, en version réduite (font plus petite)
@media (max-width: 767.98px) {
    .gyneco-status-actions {
        flex-wrap: nowrap;
        gap: 0.25rem;
    }
    .gyneco-status-actions .btn {
        flex: 1 1 0;
        min-width: 0;
        font-size: 0.7rem;
        padding: 0.25rem 0.4rem;
    }
    .gyneco-status-actions .sanitary-check {
        width: 0.8rem;
        height: 0.8rem;
    }
}
</style>
